import { Stack, Typography, useTheme } from '@mui/material';

import { ProgressDotsProps } from '@/types/components/data-display';

import { getDataTestId } from '@/utils/browser';

import { ProgressDot } from './Indicator.styled';

export function ProgressDots({
  className,
  value,
  total,
  text,
  isOnDark,
  activeColor,
  inactiveColor,
}: ProgressDotsProps) {
  const theme = useTheme();

  const highlightColor = activeColor?.(theme);
  const normalColor = inactiveColor?.(theme);

  return (
    <Stack
      className={className}
      direction="column"
      alignItems="center"
      gap={1.25}
      {...getDataTestId(`progress-dots`)}
    >
      <Stack gap={1}>
        {[...Array(total)].map((_, index) => (
          <ProgressDot
            key={`progress-dot-${index}`}
            isHighlight={index < value}
            isOnDark={isOnDark}
            activeColor={highlightColor}
            inactiveColor={normalColor}
            {...getDataTestId(`progress-dot-${index}`)}
          />
        ))}
      </Stack>
      <Typography variant="body2" textAlign="center">
        {text ?? `${value}/${total}`}
      </Typography>
    </Stack>
  );
}
